import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { CookiesService } from '@app/core/services/cookies.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { primengImports } from '@app/core/primeng';

@Component({
  selector: 'app-signin',
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, ...primengImports],
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.scss'
})
export class SigninComponent {
  loginForm: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    private cookieService: CookiesService,
    private messageService: MessageService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(){
    if(this.authService.isAuthenticated()){
      this.router.navigate(['bienvenue']);
    }
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    const credentials = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
    }
    this.authService.login(credentials);
  }

  onForgotPassword() {
    this.router.navigate(['reset-password']);
  }

  onSignUp(){
    this.router.navigate(['inscription']);
  }
}
